
import { defineComponent, ref, onMounted } from "vue";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";

interface ServerRow {
  id: string;
  serverName: string;
  pdpServer?: boolean;
  lrpServer?: boolean;
  urlHttp: string;
  zoneName: string;
}

export default defineComponent({
  name: "AgPdpLrpChooseModal",
  setup(_, { emit }) {
    const store = useStore();
    const selectedRole = localStorage.getItem("selectedRole");
    const selectedScopeId = localStorage.getItem("selectedScopeId");
    const partner = localStorage.getItem("partner");
    const partnerGuid = partner ? JSON.parse(partner)?.guid : "";
    const company = localStorage.getItem("company");
    const companyGuid = company ? JSON.parse(company)?.companyGuid : "";
    const site = localStorage.getItem("site");
    const siteGuid = site ? JSON.parse(site)?.key : "";
    const group = localStorage.getItem("group");
    const groupGuid = group ? JSON.parse(group)?.key : "";
    
    const modalData = ref<{ rows: ServerRow[] }>({
      rows: []
    });

    const selectedServers = ref<ServerRow[]>([]);

    const getList = async () => {
      try {
        const body = {
          PdpLrpPageRole: selectedRole,
          SelectedScopeId: selectedScopeId,
          PartnerId : partnerGuid,
          CompanyId : companyGuid,
          SiteId : siteGuid,
          GroupId: groupGuid
        };
        const response = await store.dispatch(GeneralActionTypes.GET_GLOBAL_SERVER, body);
     
        if (Array.isArray(response) && response.length > 0) {
          modalData.value.rows = response as ServerRow[];  
          selectedServers.value = [];
        } else {
          modalData.value.rows = [];
        }
      } catch (error) {
        console.error("Error", error);
        modalData.value.rows = [];
      }
    };

    const confirmSelection = () => {
      if (selectedServers.value.length > 0) {
        const model = {
          ServerViewModelList: selectedServers.value, 
          PdpLrpPageRole: selectedRole,  
          SelectedScopeId: selectedScopeId ,
          PartnerId : partnerGuid,
          CompanyId : companyGuid,
          SiteId : siteGuid,
          GroupId: groupGuid,
          IsInherited: false
        };
        store.dispatch(GeneralActionTypes.SELECT_OR_INHERIT_SERVER, model)
          .then(response => {
            emit("formsuccesschoose", selectedServers.value);
            window.location.reload(); 
          })
          .catch(error => {
            console.error("Error while sending data", error);
          });
      }
    };

    onMounted(() => {
      getList();
      const modal = document.getElementById("agPdpLrpChooseModal");
      if (modal) {
        modal.addEventListener("modal-open", getList);
      }
    });

    return { modalData, selectedServers, confirmSelection, getList};
  },
});
